import type { TranslationCatalog } from '../../shared/i18n';

export const translations: TranslationCatalog = {
  "Bitte eine gültige Zahl eingeben.": {
    "tr": "Lütfen geçerli bir sayı girin.",
    "en": "Please enter a valid number."
  },
  "Neuer Beleg": {
    "tr": "Yeni belge",
    "en": "New document"
  },
  "Beleg ändern": {
    "tr": "Belgeyi düzenle",
    "en": "Edit document"
  },
  "Belegliste": {
    "tr": "Belge listesi",
    "en": "Document list"
  },
  "Aufträge": {
    "tr": "Siparişler",
    "en": "Orders"
  },
  "Nr.": {
    "tr": "No.",
    "en": "No."
  },
  "Art.Nr": {
    "tr": "Ürün no.",
    "en": "Product no."
  },
  "Bezeichnung": {
    "tr": "Açıklama",
    "en": "Description"
  },
  "VPE": {
    "tr": "Koli içi",
    "en": "Pack size"
  },
  "Menge": {
    "tr": "Miktar",
    "en": "Quantity"
  },
  "E-preis": {
    "tr": "Birim fiyat",
    "en": "Unit price"
  },
  "Ste. %": {
    "tr": "Vergi %",
    "en": "Tax %"
  },
  "AR%": {
    "tr": "İsk. %",
    "en": "Disc. %"
  },
  "G-Preis": {
    "tr": "Toplam fiyat",
    "en": "Total price"
  },
  "Beleg wird geladen …": {
    "tr": "Belge yükleniyor …",
    "en": "Loading document …"
  },
  "(Neu)": {
    "tr": "(Yeni)",
    "en": "(New)"
  },
  "Speicherstatus klären / erneut senden": {
    "tr": "Kayıt durumunu kontrol et / tekrar gönder",
    "en": "Check save status / resend"
  },
  "Bitte zuerst speichern": {
    "tr": "Önce kaydedin",
    "en": "Please save first"
  },
  "Umwandeln …": {
    "tr": "Dönüştür …",
    "en": "Convert …"
  },
  "Preise aktualisieren": {
    "tr": "Fiyatları güncelle",
    "en": "Update prices"
  },
  "Druck/PDF ist zurückgestellt": {
    "tr": "Yazdırma/PDF sonraki aşamada",
    "en": "Print/PDF is deferred"
  },
  "Drucken (später)": {
    "tr": "Yazdır (sonraki aşama)",
    "en": "Print (later)"
  },
  "Die Antwort ist unklar. Eingaben bleiben gesperrt, bis derselbe Speichervorgang erneut bestätigt wurde.": {
    "tr": "Yanıt belirsiz. Aynı kayıt işlemi tekrar doğrulanana kadar girişler kilitli kalır.",
    "en": "The response is uncertain. Editing stays locked until the same save request is confirmed again."
  },
  "Belegart": {
    "tr": "Belge türü",
    "en": "Document type"
  },
  "Beleg Nr.": {
    "tr": "Belge no.",
    "en": "Document no."
  },
  "automatisch": {
    "tr": "otomatik",
    "en": "automatic"
  },
  "Datum": {
    "tr": "Tarih",
    "en": "Date"
  },
  "Vertreter": {
    "tr": "Temsilci",
    "en": "Representative"
  },
  "Lager": {
    "tr": "Depo",
    "en": "Warehouse"
  },
  "Ziellager": {
    "tr": "Hedef depo",
    "en": "Destination warehouse"
  },
  "Lieferant": {
    "tr": "Tedarikçi",
    "en": "Supplier"
  },
  "Kunde": {
    "tr": "Müşteri",
    "en": "Customer"
  },
  "Auswählen …": {
    "tr": "Seç …",
    "en": "Select …"
  },
  "Offen": {
    "tr": "Açık",
    "en": "Open"
  },
  "Saldo": {
    "tr": "Bakiye",
    "en": "Balance"
  },
  "VK": {
    "tr": "SF",
    "en": "SP"
  },
  "Bemerkung": {
    "tr": "Not",
    "en": "Note"
  },
  "Währung": {
    "tr": "Para birimi",
    "en": "Currency"
  },
  "Kurs": {
    "tr": "Kur",
    "en": "Exchange rate"
  },
  "Transport": {
    "tr": "Nakliye",
    "en": "Freight"
  },
  "Artikelsuche": {
    "tr": "Ürün arama",
    "en": "Product search"
  },
  "Artikel werden geladen …": {
    "tr": "Ürünler yükleniyor …",
    "en": "Loading products …"
  },
  "VK1": {
    "tr": "Satış 1",
    "en": "Sale 1"
  },
  "Artikel auswählen …": {
    "tr": "Ürün seç …",
    "en": "Select item …"
  },
  "Position ändern": {
    "tr": "Satırı düzenle",
    "en": "Edit line"
  },
  "Leerzeile": {
    "tr": "Boş satır",
    "en": "Blank line"
  },
  "Entfernen": {
    "tr": "Kaldır",
    "en": "Remove"
  },
  "Einfügen …": {
    "tr": "Yapıştır …",
    "en": "Paste …"
  },
  "Aus Beleg …": {
    "tr": "Belgeden …",
    "en": "From document …"
  },
  "Beträge werden berechnet …": {
    "tr": "Tutarlar hesaplanıyor …",
    "en": "Calculating amounts …"
  },
  "Steuern inklusive": {
    "tr": "Vergi dahil",
    "en": "Tax included"
  },
  "Rabatt %": {
    "tr": "İskonto %",
    "en": "Discount %"
  },
  "MwSt%": {
    "tr": "KDV%",
    "en": "VAT%"
  },
  "Vornetto": {
    "tr": "İsk. öncesi net",
    "en": "Pre-discount net"
  },
  "Rab.": {
    "tr": "İsk.",
    "en": "Disc."
  },
  "Netto": {
    "tr": "Net",
    "en": "Net"
  },
  "MwSt": {
    "tr": "KDV",
    "en": "VAT"
  },
  "Brutto": {
    "tr": "Brüt",
    "en": "Gross"
  },
  "Gesamt": {
    "tr": "Toplam",
    "en": "Total"
  },
  "Positionsrabatt": {
    "tr": "Satır iskontosu",
    "en": "Line discount"
  },
  "Zahlung": {
    "tr": "Ödeme",
    "en": "Payment"
  },
  "Zahlungsart": {
    "tr": "Ödeme şekli",
    "en": "Payment method"
  },
  "Kasse": {
    "tr": "Kasa",
    "en": "Cash"
  },
  "Bank": {
    "tr": "Banka",
    "en": "Bank"
  },
  "Die Auswahl überschreitet die Beleggrenze von 2000 Positionen. Bitte die Artikelsuche eingrenzen.": {
    "tr": "Seçim, belge başına 2000 satır sınırını aşıyor. Ürün aramasını daraltın.",
    "en": "The selection exceeds the document limit of 2000 lines. Narrow the item search."
  },
  "Beleg umwandeln": {
    "tr": "Belgeyi dönüştür",
    "en": "Convert document"
  },
  "Speicherstatus klären": {
    "tr": "Kayıt durumunu kontrol et",
    "en": "Check save status"
  },
  "Umwandeln": {
    "tr": "Dönüştür",
    "en": "Convert"
  },
  "Bitte den Beleg vor der Umwandlung speichern. Ein Lieferschein wird als neuer Beleg kopiert.": {
    "tr": "Dönüştürmeden önce belgeyi kaydedin. İrsaliye yeni bir belge olarak kopyalanır.",
    "en": "Save the document before conversion. A delivery note is copied as a new document."
  },
  "Artikel und Menge einfügen": {
    "tr": "Ürün ve miktar yapıştır",
    "en": "Paste items and quantities"
  },
  "Übernehmen": {
    "tr": "Uygula",
    "en": "Apply"
  },
  "Eine Zeile je Artikel: Artikelnummer, Tabulator, Menge.": {
    "tr": "Her ürün için bir satır: ürün numarası, sekme, miktar.",
    "en": "One line per item: item number, tab, quantity."
  },
  "Artikel auswählen": {
    "tr": "Ürün seç",
    "en": "Select product"
  },
  "Position {code}": {
    "tr": "Satır {code}",
    "en": "Line {code}"
  },
  "Brutto kg / Stück": {
    "tr": "Brüt kg / adet",
    "en": "Gross kg / unit"
  },
  "Zoll / 100 kg": {
    "tr": "Gümrük / 100 kg",
    "en": "Customs / 100 kg"
  },
  "Gesamt kg": {
    "tr": "Toplam kg",
    "en": "Total kg"
  },
  "Kostenbindung": {
    "tr": "Maliyet kilidi",
    "en": "Cost lock"
  },
  "Preishistorie": {
    "tr": "Fiyat geçmişi",
    "en": "Price history"
  },
  "Preishistorie wird geladen …": {
    "tr": "Fiyat geçmişi yükleniyor …",
    "en": "Loading price history …"
  },
  "Beleg": {
    "tr": "Belge",
    "en": "Document"
  },
  "Lagerbestand": {
    "tr": "Depo stoku",
    "en": "Warehouse stock"
  },
  "Lagerbestand wird geladen …": {
    "tr": "Depo stoku yükleniyor …",
    "en": "Loading warehouse stock …"
  },
  "Bestand": {
    "tr": "Stok",
    "en": "Stock"
  },
  "Lieferant auswählen": {
    "tr": "Tedarikçi seç",
    "en": "Select supplier"
  },
  "Kunde auswählen": {
    "tr": "Müşteri seç",
    "en": "Select customer"
  },
  "Suchen": {
    "tr": "Ara",
    "en": "Search"
  },
  "Konten werden geladen …": {
    "tr": "Hesaplar yükleniyor …",
    "en": "Loading accounts …"
  },
  "Name": {
    "tr": "Ad",
    "en": "Name"
  },
  "Ort": {
    "tr": "Şehir",
    "en": "City"
  },
  "Positionen aus Beleg übernehmen": {
    "tr": "Belgeden satırları al",
    "en": "Copy lines from document"
  },
  "Beleg suchen": {
    "tr": "Belge ara",
    "en": "Search documents"
  },
  "Artikelpositionen ersetzen die Zeilen ab der ausgewählten Position.": {
    "tr": "Ürün satırları, seçili satırdan itibaren mevcut satırların yerini alır.",
    "en": "Item lines replace rows starting at the selected position."
  },
  "Positionen werden geladen …": {
    "tr": "Satırlar yükleniyor …",
    "en": "Loading lines …"
  },
  "Belege werden geladen …": {
    "tr": "Belgeler yükleniyor …",
    "en": "Loading documents …"
  },
  "Von": {
    "tr": "Başlangıç",
    "en": "From"
  },
  "Bis": {
    "tr": "Bitiş",
    "en": "To"
  },
  "Alle": {
    "tr": "Tümü",
    "en": "All"
  },
  "Öffnen": {
    "tr": "Aç",
    "en": "Open"
  },
  "Löschstatus klären / erneut senden": {
    "tr": "Silme durumunu kontrol et / tekrar gönder",
    "en": "Check deletion status / resend"
  },
  "Die Löschantwort ist unklar. Bitte denselben Vorgang erneut senden; andere Löschungen und das Schließen bleiben gesperrt.": {
    "tr": "Silme yanıtı belirsiz. Aynı işlemi tekrar gönderin; diğer silme işlemleri ve kapatma kilitli kalır.",
    "en": "The deletion response is uncertain. Resend the same request; other deletions and closing remain blocked."
  },
  "Konto Nr.": {
    "tr": "Hesap no.",
    "en": "Account no."
  },
  "Laden …": {
    "tr": "Yükleniyor …",
    "en": "Loading …"
  },
  "Auftrag löschen?": {
    "tr": "Sipariş silinsin mi?",
    "en": "Delete order?"
  },
  "Dieser Artikel ist bereits enthalten. Noch einmal hinzufügen?": {
    "tr": "Bu ürün zaten mevcut. Tekrar eklensin mi?",
    "en": "This item is already included. Add it again?"
  },
  "Artikel {code} ist bereits enthalten. Noch einmal hinzufügen?": {
    "tr": "{code} ürünü zaten mevcut. Tekrar eklensin mi?",
    "en": "Item {code} is already included. Add it again?"
  },
  "Lieferschein": {
    "tr": "İrsaliye",
    "en": "Delivery note"
  },
  "Lieferschein als Kopie gespeichert. Ursprungsbeleg bleibt erhalten.": {
    "tr": "İrsaliye kopya olarak kaydedildi. Asıl belge korundu.",
    "en": "Delivery note saved as a copy. The original document is retained."
  },
  "Gespeichert.": {
    "tr": "Kaydedildi.",
    "en": "Saved."
  },
  "Zeile {line}: Artikelnummer und Menge (Tabulator) erforderlich.": {
    "tr": "Satır {line}: Ürün numarası ve miktar (sekme ile ayrılmış) gerekli.",
    "en": "Line {line}: item number and quantity (tab-separated) are required."
  },
  "Zeile {line}: Artikel {code} nicht gefunden.": {
    "tr": "Satır {line}: {code} ürünü bulunamadı.",
    "en": "Line {line}: item {code} was not found."
  },
  "Rechnung": {
    "tr": "Fatura",
    "en": "Invoice"
  },
  "Rechnungen": {
    "tr": "Faturalar",
    "en": "Invoices"
  },
  "Gutschrift": {
    "tr": "Alacak dekontu",
    "en": "Credit note"
  },
  "Angebot": {
    "tr": "Teklif",
    "en": "Quotation"
  },
  "Bestellung": {
    "tr": "Sipariş",
    "en": "Order"
  },
  "Auftrag": {
    "tr": "Sipariş",
    "en": "Order"
  },
  "Online-Auftrag": {
    "tr": "Çevrimiçi sipariş",
    "en": "Online order"
  },
  "Einkaufsrechnung": {
    "tr": "Alış faturası",
    "en": "Purchase invoice"
  },
  "Einkaufslieferschein": {
    "tr": "Alış irsaliyesi",
    "en": "Purchase delivery note"
  },
  "Lieferantenrechnung": {
    "tr": "Tedarikçi faturası",
    "en": "Supplier invoice"
  },
  "Wareneingang": {
    "tr": "Mal girişi",
    "en": "Goods receipt"
  },
  "Warenausgang": {
    "tr": "Mal çıkışı",
    "en": "Goods issue"
  },
  "Lagerumbuchung": {
    "tr": "Depolar arası transfer",
    "en": "Warehouse transfer"
  },
  "Inventur": {
    "tr": "Sayım",
    "en": "Stock count"
  },
  "Jahr": {
    "tr": "Yıl",
    "en": "Year"
  },
  "Zeitraum": {
    "tr": "Dönem",
    "en": "Period"
  },
  "Nur Online-Aufträge können hier gelöscht werden.": {
    "tr": "Buradan yalnızca çevrimiçi siparişler silinebilir.",
    "en": "Only online orders can be deleted here."
  }
};
